import React, { useState } from 'react';
import Button from '../../components/Button';
import Row from '../../components/Row';
import Input from '../../components/Input';
import * as client from '../../services/client';
import { toast } from 'react-toastify';
import Select from '../../components/Select';

const ServiceLog = ({ serviceRequestId, actualTime, estimatedTime }) => {
  if (actualTime == undefined || actualTime == null || actualTime == '') {
    let servicelogs = JSON.parse(localStorage.getItem('ServiceLog'));
    if (
      servicelogs != undefined &&
      servicelogs != null &&
      servicelogs != '' &&
      serviceRequestId == servicelogs.ServiceRequestId
    )
      actualTime = servicelogs.ActualTime;
  } else if (
    actualTime != undefined &&
    actualTime != null &&
    actualTime != ''
  ) {
    let servicelogs = JSON.parse(localStorage.getItem('ServiceLog'));
    if (
      servicelogs != undefined &&
      servicelogs != null &&
      servicelogs != '' &&
      serviceRequestId == servicelogs.ServiceRequestId
    )
      actualTime = servicelogs.ActualTime;
  }
  if (
    estimatedTime == undefined ||
    estimatedTime == null ||
    estimatedTime == ''
  ) {
    let servicelogs = JSON.parse(localStorage.getItem('ServiceLog'));
    if (
      servicelogs != undefined &&
      servicelogs != null &&
      servicelogs != '' &&
      serviceRequestId == servicelogs.ServiceRequestId
    )
      estimatedTime = servicelogs.EstimatedTime;
  } else if (
    estimatedTime != undefined &&
    estimatedTime != null &&
    estimatedTime != ''
  ) {
    let servicelogs = JSON.parse(localStorage.getItem('ServiceLog'));
    if (
      servicelogs != undefined &&
      servicelogs != null &&
      servicelogs != '' &&
      serviceRequestId == servicelogs.ServiceRequestId
    )
      estimatedTime = servicelogs.EstimatedTime;
  }
  let _actualDay = !!actualTime ? actualTime.split('d')[0] : 0;
  let _actualHour = !!actualTime
    ? actualTime.split('d')[1].split('h')[0].trim()
    : 0;
  let _actualMinutes = !!actualTime
    ? actualTime.split('d')[1].split('h')[1].split('m')[0].trim()
    : 0;

  let _estimatedDay = !!estimatedTime ? estimatedTime.split('d')[0] : 0;
  let _estimateHour = !!estimatedTime
    ? estimatedTime.split('d')[1].split('h')[0].trim()
    : 0;
  let _estimateMinutes = !!estimatedTime
    ? estimatedTime.split('d')[1].split('h')[1].split('m')[0].trim()
    : 0;

  const [estimateDay, setEstimateDay] = useState(_estimatedDay);
  const [estimateHour, setEstimateHour] = useState(_estimateHour);
  const [estimateMinutes, setEstimateMinutes] = useState(_estimateMinutes);

  const [actualDay, setActualDay] = useState(_actualDay);
  const [actualHour, setActualHour] = useState(_actualHour);
  const [actualMinutes, setActualMinutes] = useState(_actualMinutes);

  const saveSeviceLog = async () => {
    try {
      let estimateDaysToMinutes = Number(estimateDay) * 24 * 60;
      let estimateHoursToMinutes = Number(estimateHour) * 60;
      let totalEstimateMinutes =
        Number(estimateDaysToMinutes) +
        Number(estimateHoursToMinutes) +
        Number(estimateMinutes);
      let actualDaysToMinutes = Number(actualDay) * 24 * 60;
      let actualHoursToMinutes = Number(actualHour) * 60;
      let totalActualMinutes =
        Number(actualDaysToMinutes) +
        Number(actualHoursToMinutes) +
        Number(actualMinutes);

      let params = {};
      params.id = serviceRequestId;
      params.EstimatedTime = '' + totalEstimateMinutes;
      params.ActualTime = '' + totalActualMinutes;

      const response = await client.saveServiceLog(params);
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            let estDays = !!estimateDay ? estimateDay + 'd' : '0d';
            let estHours = !!estimateHour ? estimateHour + 'h' : '0h';
            let estMinutes = !!estimateMinutes ? estimateMinutes + 'm' : '0m';

            estimatedTime = estDays + ' ' + estHours + ' ' + estMinutes;

            let actDays = !!actualDay ? actualDay + 'd' : '0d';
            let actHours = !!actualHour ? actualHour + 'h' : '0h';
            let actMinutes = !!actualMinutes ? actualMinutes + 'm' : '0m';

            actualTime = actDays + ' ' + actHours + ' ' + actMinutes;

            localStorage.removeItem('ServiceLog');
            localStorage.setItem(
              'ServiceLog',
              JSON.stringify({
                ServiceRequestId: serviceRequestId,
                ActualTime: actualTime,
                EstimatedTime: estimatedTime,
              })
            );
            toast.success('Service Log saved successfully.', {
              autoClose: 5000,
              position: 'top-center',
            });
          } else {
            toast.error(
              'Sorry, we cannot save the Service Log at this time.  Please try again later.',
              {
                autoClose: 5000,
                position: 'top-center',
              }
            );
          }
        });
      } else {
      }
    } catch (ex) {}
  };

  return (
    <div style={{ padding: '0 30px', marginTop: '15px' }}>
      <Row>
        <div class="col-md-3" style={{ marginTop: '34px' }}>
          <label style={{ fontWeight: 'bold' }}>Estimated Time</label>
        </div>
        <div class="col-md-3">
          <Input
            value={estimateDay}
            onChange={(e) => {
              setEstimateDay(e.target.value.replace(/\D/, ''));
            }}
            block
            label="Days"
          />
        </div>
        <div class="col-md-3">
          <Select
            value={estimateHour}
            options={[...Array(24)].map((_, i) => ({
              value: i,
              label: i,
            }))}
            label="Hours"
            onChange={(e) => {
              setEstimateHour(e.target.value);
            }}
            placeholder="Select Hours"
            required={false}
          />
        </div>
        <div class="col-md-3">
          <Select
            value={estimateMinutes}
            options={[...Array(60)].map((_, i) => ({
              value: i,
              label: i,
            }))}
            label="Minutes"
            onChange={(e) => {
              setEstimateMinutes(e.target.value);
            }}
            placeholder="Select Minutes"
            required={false}
          />
        </div>
      </Row>
      <Row>
        <div class="col-md-3" style={{ marginTop: '34px' }}>
          <label style={{ fontWeight: 'bold' }}>Actual Time </label>
        </div>
        <div class="col-md-3">
          <Input
            value={actualDay}
            onChange={(e) => {
              setActualDay(e.target.value.replace(/\D/, ''));
            }}
            block
            label="Days"
          />
        </div>
        <div class="col-md-3">
          <Select
            value={actualHour}
            options={[...Array(24)].map((_, i) => ({
              value: i,
              label: i,
            }))}
            label="Hours"
            onChange={(e) => {
              setActualHour(e.target.value);
            }}
            placeholder="Select Hours"
            required={false}
          />
        </div>
        <div class="col-md-3">
          <Select
            value={actualMinutes}
            options={[...Array(60)].map((_, i) => ({
              value: i,
              label: i,
            }))}
            label="Minutes"
            onChange={(e) => {
              setActualMinutes(e.target.value);
            }}
            placeholder="Select Minutes"
            required={false}
          />
        </div>
      </Row>
      <Row>
        <div class="col-md-12" style={{ textAlign: 'center' }}>
          <Button
            color="teal"
            size="small"
            onClick={saveSeviceLog}
            label="Save"
          ></Button>
        </div>
      </Row>
    </div>
  );
};
export default ServiceLog;
